/**
 * Password validation utility
 * Centralized password validation logic for consistency across the application
 */

/**
 * Password validation regex
 * Requirements:
 * - Minimum 8 characters
 * - At least 1 letter (A-Z or a-z)
 * - At least 1 digit (0-9)
 * - At least 1 special symbol
 *
 * Allowed special symbols: !@#$%^&*()_+-=[]{}|;':",./<>?`~
 */
export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{}|;':",./<>?`~])[A-Za-z\d!@#$%^&*()_+\-=[\]{}|;':",./<>?`~]{8,}$/;

/**
 * Validate password against requirements
 * @param password - The password to validate
 * @returns true if password meets all requirements
 */
export const validatePassword = (password: string): boolean => {
  return PASSWORD_REGEX.test(password);
};
